/* eslint-disable max-len */
import {Component} from 'inferno'; // eslint-disable-line @typescript-eslint/no-unused-vars
import {Link, CustomComponent} from '../../../common/components';
import {QUICK_START_CODE} from '../../constants/code/_code';
import {ExampleCode} from '../ExampleCode';


export class QuickstartSection extends CustomComponent {
    img = {
        facebook: '/assets/img/about/about-us/apipartners/facebook.png',
        twitter: '/assets/img/about/about-us/apipartners/twitter.png',
        whatsapp: '/assets/img/about/about-us/apipartners/whatsapp.png',
        gboard: '/assets/img/about/about-us/apipartners/gboard.png',
        linkedin: '/assets/img/about/about-us/apipartners/linkedin.png',
        excitedGIF: 'https://media1.tenor.com/images/c7504b9fb03c95b3b5687d744687e11c/tenor.gif?itemid=7212866',
        launchIMG: '/assets/img/api/launch.mp4',
        autocompleteIMG: '/assets/img/api/autocomplete.mp4',
        suggestionsIMG: '/assets/img/api/suggestions.mp4',
    };
    render() {
        return (
            <div id="quickstart">
                <h1>Quickstart Guide</h1>
                <section className="narrow no-border">
                    <p>
            Welcome to Tenor! Tenor takes a data-centric approach to delivering the most relevant GIF search in over 35 languages worldwide. Integrate Tenor GIF search into your application in a matter of minutes.
                    </p>
                </section>
                <section className="narrow">
                    <div className="logos row">
                        <img className="facebook" src={this.img.facebook}/>
                        <img className="twitter" src={this.img.twitter}/>
                        <img className="whatsapp" src={this.img.whatsapp}/>
                        <img className="gboard" src={this.img.gboard}/>
                        <img className="linkedin" src={this.img.linkedin}/>
                    </div>
                    <div className="logos rows">
                        <div>
                            <img className="twitter" height="37px" src={this.img.twitter}/>
                            <img className="facebook" height="25px" src={this.img.facebook}/>
                            <img className="gboard" height="46px" src={this.img.gboard}/>
                        </div>
                        <div>
                            <img className="whatsapp" height="31px" src={this.img.whatsapp}/>
                            <img className="linkedin" height="31px" src={this.img.linkedin}/>
                        </div>
                    </div>
                </section>

                <section className="highlights wide no-border">
                    <section className="highlights-header narrow no-border">
                        <h2 className=" ">API Highlights</h2>
                        <p>
                Tenor’s GIF Keyboard is the top-downloaded mobile GIF-sharing app and developers can incorporate every feature of Tenor into their own application with our APIs. Highlights include:
                        </p>
                    </section>
                    <div className="highlights-body">
                        <div className="highlights-column">
                            <div className="highlights-item">
                                <img src="/assets/img/api/search-blue.svg"/>
                                <div>
                        Search across the most engaging and relevant GIFs on the internet
                                </div>
                            </div>
                            <div className="highlights-item">
                                <img src="/assets/img/api/layers-blue.svg"/>
                                <div>
                        Rich features to ensure your users find the most precise GIF quickly
                                </div>
                            </div>
                        </div>
                        <div className="highlights-column">
                            <div className="highlights-item">
                                <img src="/assets/img/api/globe-blue.svg"/>
                                <div>
                        Support for 35+ languages, localized content and regional content appropriateness
                                </div>
                            </div>
                            <div className="highlights-item">
                                <img src="/assets/img/api/attribution-blue.svg"/>
                                <div>
                        Optimized to deliver GIFs that load and consume less bandwidth for every use case
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section id="quickstart-setup" className="callout-section">
                    <div className="callout-box wide">
                        <h6>BEFORE YOU BEGIN</h6>
                        <h2>Get a Tenor API Key</h2>
                        <p>
                Get a free API key for your app in less than 60 seconds. View your key in your <Link to="/developer/dashboard" external={true} clickLabel="api-docs-quickstart-developer-dashboard">developer dashboard</Link>.
                        </p>
                    </div>
                </section>

                <section>
                    <section id="quickstart-search" className="narrow">
                        <h2>Step 1 - Implement Search</h2>
                        <p>
                Tenor Search delivers the most relevant and engaging GIFs in 35+ languages. Tenor receives over 300 million searches per day and continuously learns the best GIF results for every query based on user search and share behavior.
                        </p>
                        <p>
                We recommend that you initial load one of the smaller optimized GIF sizes for previews (<Link to='#responseobjects-gifformat'>response object “tinygif”</Link>), then load and display the full sized GIF (<Link to='#responseobjects-gifformat'>response object “gif“</Link>) when the user shares.
                        </p>
                        <p>
                For our example search request, we’ll be using the <Link to='#endpoints-search'>search endpoint</Link> and requesting the top 8 ranked GIFs for the search term “excited”.
                        </p>
                    </section>

                    <section>
                        <ExampleCode code={QUICK_START_CODE['search']} />
                    </section>
                </section>

                <section id="quickstart-share" className="wide">
                    <section className="narrow">
                        <h2>Step 2 - Implement Share Events</h2>
                        <p>
                When a user selects a GIF to share, send a corresponding share event to Tenor. Share events help Tenor’s Search Engine AI tune search results, helping users find the perfect GIF.
                        </p>
                        <p>
                For our example, we’re using the <Link to='#endpoints-registershare'>registered shared endpoint</Link> with the 1st GIF result returned for the search term “excited”
                        </p>
                    </section>

                    <section>
                        <ExampleCode code={QUICK_START_CODE['registershare']} />
                    </section>

                    <section className="callout-section">
                        <div className="callout-box wide">
                            <h6>ATTRIBUTION</h6>
                            <h2>Review Attribution Examples</h2>
                            <p>
                    All content retrieved from Tenor must be properly attributed by including one of the three <Link to='#attribution'>Attribution options</Link>.
                            </p>
                        </div>
                    </section>

                    <section>
                        <h2>Congratulations! You’ve successfully integrated with Tenor’s API!</h2>
                        <div className="center-item">
                            <img src={this.img.excitedGIF} width="324px" height="257px"/>
                        </div>
                        <p>Now let’s improve the user experience!</p>
                    </section>

                </section>

                <section id="quickstart-enhancedsearch" className="wide">
                    <section className="narrow">
                        <h2>Step 3 - Enrich the Search Experience</h2>
                        <p>
                In this step we’ll review best practices that improve the user experience and increase searches and shares from your Tenor GIF integration.
                        </p>
                    </section>

                    <section>
                        <section className="narrow">
                            <h2>A - Launching your Search experience</h2>
                            <p>
                    We have found the best initial experience is to display a clean search bar followed by categories of GIFs (from the <Link to='#endpoints-categories'>categories endpoint</Link>) and trending search terms (from the <Link to='#endpoints-trendingterms'>Trending Search Terms endpoint</Link>). Alternatively, trending GIFs (from the <Link to='#endpoints-trendinggifs'>Trending GIFs endpoint</Link>) can be displayed beneath search.
                            </p>
                            <div className="center-item">
                                <div className="video-border">
                                    <video
                                        muted={true}
                                        playsInline={true}
                                        autoPlay={true}
                                        loop={true}
                                        className="launch"
                                    >
                                        <source src={this.img.launchIMG} type="video/mp4" />
                                    </video>
                                </div>
                            </div>
                            <p>
                    (Optional) Use the Locale parameter. As Tenor’s service evolves, locale will be used to better tune search results to your users’ specific languages, cultures, and social trends. Using Locale will give higher preference to the user’s given locale, though it will not limit trending results to only the provided code and language typed, but gives higher preference to the given locale. The default value is en_US.
                            </p>
                            <p>
                    In the example below we’ll fetch Tenor categories and trending GIFs to display to the user.
                            </p>
                        </section>

                        <section>
                            <ExampleCode code={QUICK_START_CODE['launch']} />
                        </section>
                    </section>

                    <section>
                        <section className="narrow">
                            <h2>B - Autocomplete Suggestions</h2>
                            <p>
                    Displaying autocomplete search options as a user is typing helps users complete GIF searches faster, which increases GIF usage and retention.
                            </p>
                            <p>
                    We recommend passing up at least two characters and the user’s locale.
                            </p>

                            <div className="center-item">
                                <div className="video-border">
                                    <video
                                        muted={true}
                                        playsInline={true}
                                        autoPlay={true}
                                        loop={true}
                                        className="autocomplete"
                                    >
                                        <source src={this.img.autocompleteIMG} type="video/mp4" />
                                    </video>
                                </div>
                            </div>
                            <p>
                    In the example below we call the <Link to='#endpoints-autocomplete'>autocomplete endpoint</Link> with partial search term of “exc” -- results are ordered by likelihood to drive a share for any given partial term.
                            </p>
                        </section>

                        <section>
                            <ExampleCode code={QUICK_START_CODE['autocomplete']} />
                        </section>
                    </section>

                    <section>
                        <section className="narrow">
                            <h2>C - Search Suggestions</h2>
                            <p>
                    Search suggestions helps a user narrow their search or discover related search terms to find a more precise GIF.
                            </p>
                            <div className="center-item">
                                <div className="video-border">
                                    <video
                                        muted={true}
                                        playsInline={true}
                                        autoPlay={true}
                                        loop={true}
                                        className="suggestions"
                                    >
                                        <source src={this.img.suggestionsIMG} type="video/mp4" />
                                    </video>
                                </div>
                            </div>
                            <p>
                    Often users don’t know exactly what they are looking for, and <Link to='#endpoints-suggestions'>search suggestions</Link> help them correct spelling mistakes or find more similar terms.
                            </p>
                            <p>
                    Results are returned in order of what is most likely to drive a GIF share for a given term. The example below returns the top 5 search suggestions for the search term “smile”:
                            </p>
                        </section>

                        <section>
                            <ExampleCode code={QUICK_START_CODE['suggestions']} />
                        </section>
                    </section>

                </section>

            </div>
        );
    }
}
